import { render, staticRenderFns } from "./copiar-oferta.vue?vue&type=template&id=28c96128&"
import script from "./copiar-oferta.vue?vue&type=script&lang=js&"
export * from "./copiar-oferta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports